<script>
  import SearchInput from "../../Common/SearchInput.svelte";
  import { queryState } from "../../../stores";

  // Search term State
  $: searchTerm = $queryState.search;

  /**
   * Submits the Top Search form
   */
  const submitForm = (term) => {
    // Filter Reports search results based on searchTerm
    if (typeof term === "string") {
      if (term) {
        queryState.update(() => ({
          search: term,
          reportTypes: null,
          sectorIds: null,
          organizations: null,
          fiscalYears: null,
          sort: null,
          pg: null,
        }));
      } else {
        queryState.update((queryState) => ({
          ...queryState,
          search: null,
          pg: null,
          sort: queryState.sort || "date",
        }));
      }
    }
  };
</script>

<div id="reports-results-search-bar">
  <div class="container">
    <form
      on:submit|preventDefault={submitForm}
      on:keydown={(e) => (e.key === "Enter" ? submitForm(e) : {})}
    >
      <SearchInput {searchTerm} buttonSearch={submitForm} />
    </form>
  </div>
</div>

<style>
  #reports-results-search-bar {
    padding: 80px 0px;
    background-color: #4a4a4a;
  }
  @media screen and (max-width: 1416px) {
    #reports-results-search-bar {
      padding: 30px 0;
    }
  }
  form {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  form :global(input) {
    margin-right: 0;
  }
</style>
